import Image from "next/image";

/**
 * Loading screen for space content
 */
export default function LoadingSpace() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
      <div className="animate-pulse">
        <Image
          src="/logos/beta/purple.svg"
          alt="Qensa Logo"
          width={200}
          height={50}
          priority
        />
      </div>
    </div>
  );
}
